/**
 * AnnouncementSlider
 *
 * Shows a full-screen announcement image if configured.
 * If no image is set, it displays a friendly placeholder message.
 */
import React from "react";

export default function AnnouncementSlider({ config }) {
  const imageUrl = config?.imageUrl;

  if (!imageUrl) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "transparent",
        }}
      >
        <div style={{ textAlign: "center", color: "#666" }}>
          <p>No announcement image configured</p>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
        overflow: "hidden",
      }}
    >
      <img
        src={imageUrl}
        alt="Announcement"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          objectPosition: "center",
        }}
        onError={(e) => {
          console.error("Failed to load announcement image:", imageUrl);
          e.target.style.display = "none";
        }}
      />
    </div>
  );
}
